<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader"; 
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import AddEdit from "./AddEdit.vue"; 
import StrIyilestirmeTur from "@/models/StrIyilestirmeTur";
export default {
  mixins: [Api, Sabit, StrIyilestirmeTur],
  page: {
    title: "İyileştirmeler",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    AddEdit,
  },
  data() {
    return {
      title: "İyileştirme Türleri",
      items: [
        {
          text: "Anasayfa",
          href: "/",
        },
        {
          text: "İyileştirme İşlemleri", 
        },
        {
          text: "İyileştirme Türleri",
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      Filter:{ 
      },
      DetayId: null
    };
  },

  methods: {
    Get() {
      var Filter = "" 
      this.ActionsFilterGet({ Service: "StrIyilestirmeTur", Page: this.Page, Filter: Filter }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
      });
    }, 
  }, 
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
           
      
 
 

              
                <div class="col-sm-12 ">
                  <div class="text-sm-end">
                    <button type="button" class="btn btn-primary btn-rounded mb-2 me-2 mt-4" v-b-modal.StrIyilestirmeTur 
                    @click="(DataUpdate = StrIyilestirmeTurData), (AddEdit = 'Add')"><i class="mdi mdi-plus me-1"></i>Yeni Kayıt Ekle</button>
                  </div>
                </div>
              </div>

              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>Tür</th>
                      <th>Kod</th> 
                      <th>İşlemler</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id">
                      <th scope="row">{{ Data.Tur }}</th> 
                      <td>{{ Data.Kod }}</td> 
                      <td>
                        <div class="action-is w-100 d-flex justify-content-center align-items-center">
                           
                          <i v-b-tooltip.hover title="Düzenle" class="fas fa-pencil-alt" v-b-modal.StrIyilestirmeTur @click="(DataUpdate = Data), (AddEdit = 'Edit')" ></i>
                          <i  v-b-tooltip.hover title="Sil" class="fas fa-trash-alt" @click="Delete('StrIyilestirmeTur', Data.Id)"  ></i> 
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage" :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table" @input="ChangePage(DefaultPage)"> </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddEdit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="Get"   /> 

      
    </Layout>
  </Loader>
</template>
